var script = function() {
  this.isEdge =
    navigator.userAgent.indexOf("Edge") !== -1 &&
    (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
  this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  this.recorder; // globally accessible
  this.microphone;

  this.startBtn;
  this.stopBtn;
  this.microphoneBtn;

  this.captureMicrophone = function(callback) {
    this.microphoneBtn.disabled = false;

    if (this.microphone) {
      callback(this.microphone);
      return;
    }

    if (
      typeof navigator.mediaDevices === "undefined" ||
      !navigator.mediaDevices.getUserMedia
    ) {
      alert("This browser does not supports WebRTC getUserMedia API.");

      if (navigator.getUserMedia) {
        alert("This browser seems supporting deprecated getUserMedia API.");
      }
    }

    navigator.mediaDevices
      .getUserMedia({
        audio: this.isEdge
          ? true
          : {
              echoCancellation: false
            }
      })
      .then(function(mic) {
        callback(mic);
      })
      .catch(function(error) {
        alert("Unable to capture your microphone. Please check console logs.");
        console.error(error);
      });
  };

  this.replaceAudio = function(src) {
    var newAudio = document.createElement("audio");
    newAudio.controls = true;
    newAudio.autoplay = true;

    if (src) {
      newAudio.src = src;
    }

    var parentNode = this.audio.parentNode;
    parentNode.innerHTML = "";
    parentNode.appendChild(newAudio);

    this.audio = newAudio;
    this.audio.setAttribute("class", "audioplayer md-image");
    this.audio.setAttribute("style", "display: inline");
  };

  this.stopRecordingCallback = function() {
    var audio = URL.createObjectURL(this.recorder.getBlob());
    this.replaceAudio(audio);
    this.callback(this.recorder.getBlob());
    this.startBtn.disabled = false;

    setTimeout(
      function() {
        if (!this.audio.paused) {
          return;
        }

        setTimeout(
          function() {
            if (!this.audio.paused) {
              return;
            }
            this.audio.play();
          }.bind(this),
          1000
        );

        this.audio.play();
      }.bind(this),
      300
    );

    this.audio.play();

    if (this.isSafari) {
      this.click(this.microphoneBtn);
    }
  }.bind(this);

  this.listener = function() {
    this.startBtn.onclick = function() {
      this.startBtn.disabled = true;
      this.startBtn.style.border = "";
      this.startBtn.style.fontSize = "";
      if (!this.microphone) {
        this.captureMicrophone(
          function(mic) {
            this.microphone = mic;

            if (this.isSafari) {
              this.replaceAudio();

              this.audio.muted = true;
              this.audio.srcObject = this.microphone;
              this.audio.setAttribute("class", "audioplayer md-image");

              this.startBtn.disabled = false;
              this.startBtn.style.border = "1px solid red";
              this.startBtn.style.fontSize = "150%";

              alert(
                "Please click startRecording button again. First time we tried to access your microphone. Now we will record it."
              );
              return;
            }

            this.click(this.startBtn);
          }.bind(this)
        );
        return;
      }

      this.replaceAudio();

      this.audio.muted = true;
      this.audio.srcObject = this.microphone;

      var options = {
        type: "audio",
        numberOfAudioChannels: this.isEdge ? 1 : 2,
        checkForInactiveTracks: true,
        bufferSize: 16384
      };

      if (this.isSafari || this.isEdge) {
        options.recorderType = this.StereoAudioRecorder;
      }

      if (
        navigator.platform &&
        navigator.platform
          .toString()
          .toLowerCase()
          .indexOf("win") === -1
      ) {
        options.sampleRate = 48000; // or 44100 or remove this line for default
      }

      if (this.isSafari) {
        options.sampleRate = 44100;
        options.bufferSize = 4096;
        options.numberOfAudioChannels = 2;
      }

      if (this.recorder) {
        this.recorder.destroy();
        this.recorder = null;
      }

      this.recorder = this.RecordRTC(this.microphone, options);
      this.recorder.startRecording();

      this.stopBtn.disabled = false;
    }.bind(this);

    this.stopBtn.onclick = function() {
      this.stopBtn.disabled = true;
      this.recorder.stopRecording(this.stopRecordingCallback);
    }.bind(this);

    this.microphoneBtn.onclick = function() {
      this.microphoneBtn.disabled = true;
      this.startBtn.disabled = false;

      if (this.microphone) {
        this.microphone.stop();
        this.microphone = null;
      }

      if (this.recorder) {
        // click(stopBtn);
      }
    }.bind(this);
  };

  this.click = function(el) {
    el.disabled = false; // make sure that element is not disabled
    var evt = document.createEvent("Event");
    evt.initEvent("click", true, true);
    el.dispatchEvent(evt);
  };

  this.getRandomString = function() {
    if (
      window.crypto &&
      window.crypto.getRandomValues &&
      navigator.userAgent.indexOf("Safari") === -1
    ) {
      var a = window.crypto.getRandomValues(new Uint32Array(3)),
        token = "";
      for (var i = 0, l = a.length; i < l; i++) {
        token += a[i].toString(36);
      }
      return token;
    } else {
      return (Math.random() * new Date().getTime())
        .toString(36)
        .replace(/\./g, "");
    }
  };

  this.getFileName = function(fileExtension) {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var date = d.getDate();
    return (
      "RecordRTC-" +
      year +
      month +
      date +
      "-" +
      this.getRandomString() +
      "." +
      fileExtension
    );
  };
};

export { script };
